import React from 'react';
import {FormikErrors, withFormik} from 'formik';
import PropTypes from 'prop-types';
import {InformationLegalRepresentativeServiceRequest} from 'commons/models';
import {InferPropTypes} from 'commons/types/Types';
import InnerFormRepresentativeOfficialInfo from './InnerFormRepresentativeOfficialInfo';
import {FieldShape} from 'commons/shapes';
import {formValidator} from 'commons/utils/Functions';

RepresentativeOfficialInfoForm.propTypes = {
    submitHandler: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
    auxLegalRepresentative: PropTypes.any,
};

const FormControl = withFormik<
    InferPropTypes<typeof RepresentativeOfficialInfoForm.propTypes>,
    InformationLegalRepresentativeServiceRequest
>({
    mapPropsToErrors: () => {
        return {
            identificationType: '',
            identificationNumber: '',
            kycId: '',
            advancedElectronicSignature: '',
            nationalityKey: '',
        };
    },
    mapPropsToValues: (props) => {
        const {auxLegalRepresentative} = props;
        if (auxLegalRepresentative) {
            return {
                identificationType: auxLegalRepresentative.identificationType || '',
                identificationNumber: auxLegalRepresentative.identificationNumber || '',
                kycId: auxLegalRepresentative.kycId || 0,
                advancedElectronicSignature:
                    auxLegalRepresentative.advancedElectronicSignature || '',
                nationalityKey: auxLegalRepresentative.nationalityKey || '',
                dniBack: auxLegalRepresentative.dniBack || '',
                dniFront: auxLegalRepresentative.dniFront || ''
            };
        } else {
            return {
                identificationType: '',
                identificationNumber: '',
                kycId: 0,
                advancedElectronicSignature: '',
                nationalityKey: '',
                dniBack: '',
                dniFront: ''
            };
        }
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: InformationLegalRepresentativeServiceRequest, props) => {
        const errors: FormikErrors<InformationLegalRepresentativeServiceRequest> = {};
        formValidator(props.fields, errors, values);
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(InnerFormRepresentativeOfficialInfo);

function RepresentativeOfficialInfoForm(
    props: InferPropTypes<typeof RepresentativeOfficialInfoForm.propTypes>
) {
    const {submitHandler, fields, auxLegalRepresentative} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl
            fields={fields}
            submitHandler={submitHandler}
            auxLegalRepresentative={auxLegalRepresentative}
        />
    );
}

export default RepresentativeOfficialInfoForm;
